import React, { Component } from 'react';
import { shape, string, number, arrayOf } from 'prop-types';
import { get } from 'lodash';
import { normalizeMetric } from '../../../helpers/validate';
import { getKeywordColumnWidth } from './../constant';

import styles from './styles.scss';
import classnames from 'classnames';

export default class KeywordTableSummary extends Component {
  static propTypes = {
    summaryData: shape({
      title: string,
      visits: number,
      adVisits: number,
      newUsers: number,
      newAdUsers: number
    }).isRequired,
    title: string,
    columnsToDisplay: arrayOf(string)
  }

  static defaultProps = {
    title: 'Grand Total',
    columnsToDisplay: ['adVisits']
  }

  render() {
    const { title, summaryData, columnsToDisplay } = this.props;
    const formattedData = {
      ...summaryData,
      adVisits: summaryData.adVisits && summaryData.adVisits.toFixed(1),
      newAdUsers: summaryData.newAdUsers && summaryData.newAdUsers.toFixed(1)
    }
    
    return (
      <div className={classnames(styles.tableRow, styles.summaryRow)}>
        <div
          className={styles.tableCell}
          style={{width: `${getKeywordColumnWidth(columnsToDisplay.length + 1, 0)}%`}}
        >
          {title}
        </div>
        {
          columnsToDisplay && columnsToDisplay.map((key, index) => {
            const value = get(formattedData, key);
            const width = getKeywordColumnWidth(columnsToDisplay.length + 1, index + 1) //need to add 1 since keywordValue is missing from summary data
            return (
              <div
                key={key}
                className={styles.tableCell}
                style={{
                  width: `${width}%`
                }}
              >
                {normalizeMetric(value)}
              </div>
            )
          })
        }
      </div>
    )
  }
}
